import React, { Component } from 'react'
import { func } from 'prop-types'
import { view } from '@risingstack/react-easy-state'
import { translate } from 'react-i18next'
import { NavigationButtons } from '../../ui/buttons/NavigationButtons'
import { stores } from '../../../stores'
import { Disponibility } from '../../ui/inputs/Disponibility'
import { validateReferences } from '../../../utilities/validators'
import { InquiryTypes } from '../../../constants/InquiryTypes'
import { pushGtmTrigger } from '../../../utilities/window'

class DisponibilitiesStepComponent extends Component {
  constructor () {
    super()
    this.state = {
      shouldSkipDisponibilities: true,
      errors: []
    }
  }

  componentDidMount () {
    pushGtmTrigger('enter_dates_v2')
    this.setShouldSkipDisponibilities(true)
  }

  updateDisponibility (index, key, value) {
    stores.inquiry.disponibilities[index] = stores.inquiry.disponibilities[index] || { date: null, daytime: null }
    stores.inquiry.disponibilities[index][key] = value
  }

  setShouldSkipDisponibilities (shouldSkipDisponibilities) {
    this.setState({ shouldSkipDisponibilities: shouldSkipDisponibilities, errors: [] })
    if (this.state.shouldSkipDisponibilities) {
      stores.inquiry.disponibilities.forEach((d, i) => {
        stores.inquiry.disponibilities[i] = { date: null, daytime: null }
      })
    }
  }

  handleSubmit () {
    let { errors } = validateReferences(this.refs)
    if (this.state.shouldSkipDisponibilities) {
      this.props.next()
    } else {
      // Remove duplicates - only used for disponibilities errors
      errors = errors.filter((x, i, a) => a.indexOf(x) === i)
      this.setState({ errors: errors })
      if (!errors.length) {
        this.props.next()
      }
    }
  }

  render () {
    const { t, previous } = this.props
    const { shouldSkipDisponibilities, errors } = this.state
    return (
      <div className='demande__container no_max_width --with-padding-bottom'>
        <div className={'radio ' + (shouldSkipDisponibilities ? 'active' : '')}
          onClick={() => this.setShouldSkipDisponibilities(true)}>
          <label className='radio__label'>
            <input className='radio__input' type='radio' value='visite'
              checked={shouldSkipDisponibilities} readOnly />
            <p className='radio__maintext'>{t('common:visits:path_v2:want_followup')}</p>
            <p className='radio__text'>{
              t(
                stores.inquiry.type === InquiryTypes.VISIT
                  ? 'common:visits:path_v2:want_followup_visit'
                  : 'common:visits:path_v2:want_followup_intervention'
              )
            }</p>
          </label>
        </div>
        <center>
          <label className='or__label'>OU</label>
        </center>
        <div className={'radio ' + (shouldSkipDisponibilities ? '' : 'active')}
          onClick={() => this.setShouldSkipDisponibilities(false)}>
          <label className='radio__label'>
            <input className='radio__input' type='radio' value='realisation'
              checked={!shouldSkipDisponibilities} readOnly />
            <p className='radio__maintext'>{t('common:visits:path_v2:want_give_disponibilities')}</p>
            <p className='radio__text'>{
              t(
                stores.inquiry.type === InquiryTypes.VISIT
                  ? 'common:visits:path_v2:want_give_disponibilities_visit'
                  : 'common:visits:path_v2:want_give_disponibilities_intervention'
              )
            }</p>
          </label>
        </div>
        {
          !shouldSkipDisponibilities && <div>
            <label style={{ fontWeight: 600 }} className={'form__label'}>
              <h3 className='demande-form__h3'>
                {t(stores.inquiry.type === InquiryTypes.VISIT ? 'common:fields:visits_disponibilities' : 'common:visits:path_v2:intervention_date')}
              </h3>
            </label>
            <div>
              <p
                className={'demande-form__text'}>{t(stores.inquiry.type === InquiryTypes.VISIT ? 'common:fields:visits_disponibilities_sublabel' : 'common:visits:path_v2:intervention_date_sublabel')}</p>
            </div>
            <div className='demande-form__disponibilites'>
              {/* warning - technical debt - name seems to be a big deal for some reasons ... */}
              <Disponibility required onChange={(v, a) => this.updateDisponibility(0, v, a)} name='0'
                ref={'disponibility_0'} label={t('common:fields:visits_disponibilities')}
                daytime={stores.inquiry.disponibilities[0].daytime}
                date={stores.inquiry.disponibilities[0].date} />
              {
                stores.inquiry.type === InquiryTypes.VISIT &&
                <Disponibility required onChange={(v, a) => this.updateDisponibility(1, v, a)} name='1'
                  ref={'disponibility_1'} label={t('common:fields:visits_disponibilities')}
                  daytime={stores.inquiry.disponibilities[1].daytime}
                  date={stores.inquiry.disponibilities[1].date} />
              }
              {stores.inquiry.type === InquiryTypes.VISIT &&
                <Disponibility required onChange={(v, a) => this.updateDisponibility(2, v, a)} name='2'
                  ref={'disponibility_2'} label={t('common:fields:visits_disponibilities')}
                  daytime={stores.inquiry.disponibilities[2].daytime}
                  date={stores.inquiry.disponibilities[2].date} />
              }
            </div>
          </div>
        }
        {
          errors.length
            ? <div className='form__errormessage' style={{ textAlign: 'center', marginBottom: '10px' }}>
              <b>{t('common:demande:errors:invalid_form')}</b>
              {errors ? errors.map((e, i) => <div key={i} style={{}}>{e}</div>) : ''}
            </div> : ''
        }
        <div className='form__submit' style={{ justifyContent: 'center' }}>
          <NavigationButtons
            previous={previous}
            next={() => this.handleSubmit()} />
        </div>
      </div>
    )
  }
}

DisponibilitiesStepComponent.propTypes = {
  t: func,
  previous: func,
  next: func
}

export const DisponibilitiesStepV2 = translate()(view(DisponibilitiesStepComponent))



// WEBPACK FOOTER //
// ./src/components/inquiry/v2/DisponibilitiesStepV2.js